export   const heightDate =  [
    {
        'name':"Hauteur Aujourd'hui",
        'value':"0"
    },
    {
        'name':"Hauteur Demain",
        'value':"1"
    },
    {
        'name':"Hauteur 4 jours",
        'value':"4"
    },
    {
        'name':"Hauteur 7 jours",
        'value':"7"
    },
    {
        'name':"Hauteur 15 jours",
        'value':"15"
    },
    {
        'name':"Hauteur 1 mois",
        'value':"31"
    },
    {
        'name':"Hauteur 2 mois",
        'value':"61"
    },
    {
        'name':"Hauteur 3 mois",
        'value':"93"
    },
    {
        'name':"Hauteur 6 mois",
        'value':"186"
    },
    {
        'name':"Hauteur 12 mois",
        'value':"365"
    },
    {
        'name':"Hauteur 26 mois",
        'value':"790"
    }
]

     